<template>
  <div>
    <v-card class="pl-5 pr-5 pb-5">
      <div class="row">
        <div class="col">
          <h1>User Devices</h1>
          <v-divider></v-divider>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" v-show="userId == 0">User</th>
                  <th class="text-left">DeviceID</th>
                  <th class="text-left">DeviceName</th>
                  <th class="text-left">MACAddress</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td v-show="userId == 0">{{ item.UserName }}</td>
                  <td>{{ item.DeviceID }}</td>
                  <td>{{ item.DeviceName }}</td>
                  <td>{{ item.MACAddress }}</td>
                  <td>
                    <v-icon
                      class="mr-2 icon-delete"
                      @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "UserDevice",
  props: {
    userId: { type: Number, required: true },
  },
  watch: {
    userId: function (newVal, oldVal) {
      console.log('newVal '+ newVal)
      if (newVal != 0 || newVal != undefined) this.getUserDevices(newVal);
      else this.getAllUserDevicesToRemove();
    },
  },
  components: {
    Notification,
    ConfirmationDialog,
  },
  created() {
    console.log(this.userId);
    if (this.userId != 0) this.getUserDevices();
    else this.getAllUserDevicesToRemove();
  },
  methods: {
    getUserDevices(userId) {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByID("user-devices/devices/user", this.userId)
          .then((response) => {
            console.log(response);
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllUserDevicesToRemove() {
      new Promise((resolve, reject) => {
        api
          .getAll("user-devices/devices/to-remove")
          .then((response) => {
            console.log(response);
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user-devices", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                 this.getUserDevices(this.userId)
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserDevice.vue